const s = "_chip_1mfkz_1", e = "_chipActions_1mfkz_20", c = "_selected_1mfkz_34", _ = {
  chip: s,
  chipActions: e,
  "size-large": "_size-large_1mfkz_28",
  "size-small": "_size-small_1mfkz_31",
  selected: c
};
export {
  s as chip,
  e as chipActions,
  _ as default,
  c as selected
};
//# sourceMappingURL=index.es713.js.map
